import React from 'react';
import PropTypes from 'prop-types';

const CellInput = ({
  value,
  setRef,
  onChange,
  onFocus,
}) => (
  <input
    className="grid-report-cell-editor-input"
    value={value}
    ref={setRef}
    onChange={onChange}
    onFocus={onFocus}
  />
);

CellInput.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  setRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default CellInput;
